// extracted by mini-css-extract-plugin
export default {"page":"NP-z","cartModal":"OP-z","checkout":"PP-z","placeholder":"QP-z","account":"RP-z"};